export interface ExperienceBiddingOption {
  value: number;
  label: string;
}

export const ExperienceBiddingOptions: ExperienceBiddingOption[] = [
  {
    value: 1,
    label: 'Nunca participei',
  },
  {
    value: 2,
    label: 'Já participei de algumas',
  },
  {
    value: 3,
    label: 'Já participei de muitas licitações',
  },
];
